import { useEffect, useMemo, useState } from 'react';
import type { InteractionProps } from '@microlink/react-json-view';
import { resolveJsonInput, serializeJsonOutput } from '~/app/utils/json';

type UseJsonViewStateParams = {
  value: unknown;
  onChange?: (value: unknown) => void;
};

export function useJsonViewState({ value, onChange }: UseJsonViewStateParams) {
  const resolved = useMemo(() => resolveJsonInput(value), [value]);
  const [src, setSrc] = useState<object | null>(
    resolved.kind === 'json' ? resolved.src : null,
  );

  useEffect(() => {
    if (resolved.kind === 'json') {
      setSrc(resolved.src);
    } else {
      setSrc(null);
    }
  }, [resolved]);

  const commitInteraction = (interaction: InteractionProps) => {
    setSrc(interaction.updated_src);
    onChange?.(serializeJsonOutput(interaction.updated_src, value));
    return true;
  };

  return {
    resolved,
    src,
    commitInteraction,
  };
}
